import PropMapper from '@v/util/PropMapper.js'

export class BillingApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BillingApiModel', instance: this, rawModel })
      .mapString('BusinessUnitKey')
      .mapString('BusinessUnitName')
      .mapBool('AccontCreatedInBillingSystem')
      .mapString('SelectedBillingProductCode')
      .mapObject('GeneralContactInformation', x => new ContactInformationApiModel(x))
      .mapObject('FinancialContactInformation', x => new ContactInformationApiModel(x))
      .mapArray('AvailableProducts', x => new ProductInformationApiModel(x))
  }
}

export class InvoiceApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'InvoiceApiModel', instance: this, rawModel })
      .mapString('Key')
      .mapString('InvoiceId')
      .mapString('Status')
      .mapString('Date')
      .mapString('DueDate')
      .mapNumber('TotalAmount')
      .mapNumber('AmountPaid')
      .mapNumber('AmountTax')
      .mapString('CurrencyCode')
      .mapString('PdfKey')
  }
}

// === ContactInformation ===

class ContactInformationApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'ContactInformationApiModel', instance: this, rawModel })
      .mapString('Key')
      .mapString('BusinessUnitKey')
      .mapString('UserAccountKey')
      .mapArray('Type')
      .mapString('Title')
      .mapString('Firstname')
      .mapString('Lastname')
      .mapString('Street')
      .mapNumber('Housenumber')
      .mapString('HousenumberSuffix')
      .mapString('Zipcode')
      .mapString('Area')
      .mapString('City')
      .mapString('State')
      .mapString('Country')
      .mapString('Email')
      .mapString('Phone')
      .mapString('Mobile')
      .mapString('ChamberOfCommerceNumber')
      .mapString('TaxNumber')
  }
}

// === ProductInformationApiModel ===

class ProductInformationApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'ProductInformationApiModel', instance: this, rawModel })
      .mapString('Code')
      .mapString('Name')
      .mapOneOf('Type', ['NotSet', 'Plan', 'Addon', 'Charge', 'UnKnown '])
  }
}
